import getIsInCheckedMode from 'mini-mail-list-store/lib/utils/getIsInCheckedMode';
import { shouldShowEmptyFolderButtonForFolderId } from 'mini-mail-empty-folder-button';
import { shouldShowFocusedOtherButton } from './shouldShowFocusedOtherButton';

/**
 * Determines if the Mail list header should be shown or not
 * @param folderId
 */
export const shouldShowMailListHeaderForFolderId = (folderId: string): boolean => {
    // In multi select mode, never show the secondary header
    if (getIsInCheckedMode()) {
        return false;
    }

    // The secondary header should be shown when there is focused other button or empty folder button
    return shouldShowFocusedOtherButton() || shouldShowEmptyFolderButtonForFolderId(folderId);
};
